import * as Yup from "yup";
import { personalInformationFields } from "../fields/personalInformation.js";
import fields$1 from "../fields/contactDetails.js";
import fields$2 from "../fields/miscellaneous.js";
import { insuranceFields } from "../fields/insurance.js";
import fields$3 from "../fields/allergiesAndMedications.js";
import fields$4 from "../fields/wishesAndExpectations.js";
import consentsFields from "../fields/consents.js";
import fields$5 from "../fields/profileInterest.js";
import "../../../../../type/Appointment.js";
import "../../components/masked-date-input/masked-date-input.js";
import "react/jsx-runtime";
import "react-i18next";
import "react-text-mask";
import "../entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../helpers/toBoolean.js";
import "../helpers/createFields.js";
import "../helpers/resetFields.js";
import "./yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../helpers/predicates.js";
import "./emailValidation.js";
import "../helpers/featureFlags.js";
import "../helpers/getAgeFromBirthday.js";
import "./buildValidationSchema.js";
import "../../../../../type/Disease.js";
import "../config/medicaments.js";
Yup.setLocale({
  mixed: {
    required: "generic_form_error"
  },
  number: {
    min: (values) => ({ key: "number_min_error", values }),
    max: (values) => ({ key: "number_max_error", values })
  }
});
const fields = {
  ...personalInformationFields,
  ...fields$1,
  ...fields$2,
  ...insuranceFields(),
  ...fields$3,
  ...fields$4(),
  ...consentsFields,
  ...fields$5
};
const combinedFields = {
  ...fields,
  allergyPassField: {
    label: "field.do_you_have_an_allergy_pass",
    name: "allergyPass",
    inputProps: {
      withText: true
    },
    validation: Yup.boolean()
  }
};
const personalInformationSchema = Yup.object().shape({
  [combinedFields.gender.name]: combinedFields.gender.validation,
  [combinedFields.firstName.name]: combinedFields.firstName.validation,
  [combinedFields.lastName.name]: combinedFields.lastName.validation,
  [combinedFields.birthday.name]: combinedFields.birthday.validation,
  [combinedFields.placeOfBirth.name]: combinedFields.placeOfBirth.validation
});
const addressSchema = Yup.object().shape({
  [combinedFields.street.name]: combinedFields.street.validation,
  [combinedFields.zipCode.name]: combinedFields.zipCode.validation,
  [combinedFields.city.name]: combinedFields.city.validation,
  [combinedFields.email.name]: combinedFields.email.validation,
  [combinedFields.phone.name]: combinedFields.phone.validation
});
const lifestyleSchema = Yup.object().shape({
  [combinedFields.occupation.name]: combinedFields.occupation.validation,
  [combinedFields.isPregnant.name]: combinedFields.isPregnant.validation,
  [combinedFields.pregnantMonths.name]: combinedFields.pregnantMonths.validation,
  [combinedFields.cigarretesPerDay.name]: combinedFields.cigarretesPerDay.validation
});
const insuranceSchema = Yup.object().shape({
  [combinedFields.type.name]: combinedFields.type.validation,
  [combinedFields.insuranceCompany.name]: combinedFields.insuranceCompany.validation,
  [combinedFields.hasCareLevel.name]: combinedFields.hasCareLevel.validation,
  [combinedFields.careLevelLimitedInTime.name]: combinedFields.careLevelLimitedInTime.validation,
  [combinedFields.entitledToIntegrationAssistance.name]: combinedFields.entitledToIntegrationAssistance.validation,
  [combinedFields.integrationAssistanceBasedOnType.name]: combinedFields.integrationAssistanceBasedOnType.validation,
  [combinedFields.holderFirstName.name]: combinedFields.holderFirstName.validation,
  [combinedFields.holderLastName.name]: combinedFields.holderLastName.validation,
  [combinedFields.holderBirthday.name]: combinedFields.holderBirthday.validation,
  [combinedFields.holderStreet.name]: combinedFields.holderStreet.validation,
  [combinedFields.holderCity.name]: combinedFields.holderCity.validation,
  [combinedFields.holderZipcode.name]: combinedFields.holderZipcode.validation,
  [combinedFields.dentalInsuranceCompany.name]: combinedFields.dentalInsuranceCompany.validation
});
const formSchema = Yup.object().shape({
  dataTruthyness: Yup.boolean().oneOf([true], "data_truthyness_error").required("data_truthyness_error")
}).concat(personalInformationSchema).concat(addressSchema).concat(lifestyleSchema).concat(insuranceSchema);
export {
  addressSchema,
  combinedFields,
  formSchema,
  insuranceSchema,
  lifestyleSchema,
  personalInformationSchema
};
